import { ExpandMore } from "@mui/icons-material";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  Card,
  Collapse,
  Typography,
  styled,
} from "@mui/material";
import moment from "moment";
import React, { memo, useEffect, useMemo, useState } from "react";
import useTimer from "../../../customHooks/useTimer";
import OrderDetails from "./OrderDetails";

const OrderHeader = styled(Box)(({ theme }) => ({
  color: "#111",
  // color: "rgb(255, 255, 255)",
  // mixBlendMode: "difference",

  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  gap: "10px",
  "& span": {
    fontSize: "18px",
    fontWeight: "500",
    letterSpacing: "2px",
  },
}));

const DetailsDiv = styled(AccordionDetails)(({ theme }) => ({
  background: "#fff",
  "& img": {
    height: "50px",
    width: "50px",
    objectFit: "contain",
    borderRadius: "5px",
  },
  "& p": {
    margin: "0",
    marginTop: "10px",
    marginBottom: "0",
  },
  "& small": {
    color: "#111",
    // color: "rgb(255, 255, 255)",
    // mixBlendMode: "difference",

    fontSize: "12px",
    lineHeight: "1.4",
  },
}));

const OrderCard = ({
  order,
  handlePickupOrder,
  handlePrint,
  handleMarkPick,
  fulfilled,
  markPick,
}) => {

  const AccDiv = styled(Accordion)(({ theme }) => ({
    background: (order.readyToFulfill === 1 && order.payments?.length < 1) ? "#f5f5f5" : (order.readyToFulfill === 1 && order.payments?.length > 0) ? "#9FE2BF" : fulfilled ? "#e6ffe6" : lightColor,
    transition: "0.3s",
    // width:"440px",
    "& h3": {
      margin: "0",
    },
    "& .MuiAccordionSummary-expandIconWrapper": {
      top: "24px",
      right: "10px",
      position: "absolute",
    },

    "& span": {
      fontSize: "15px",
      color: "#111",
    },
    "& button": {
      textTransform: "none",
    },
    "& svg": {
      color: "#111",
      // color: "rgb(255, 255, 255)",
      // mixBlendMode: "difference",
    },
  }));

  const [open, setOpen] = useState(true);

  const TimerHook = useMemo(() => useTimer, [order?.created_at]);
  const { currentTimer, lightColor } = TimerHook(order?.created_at);

  // console.log('lightColor',lightColor)

  const handlePick = () => {
    handlePickupOrder(order);
  };

  const attributes = JSON.parse(order?.attributes);
  const attributeValue = attributes && attributes[0].attributeValue;

  return (
    <AccDiv expanded={open} onChange={() => setOpen(!open)}>
      <AccordionSummary expandIcon={<ExpandMore />}>
        <Box>
          <OrderHeader>
            <h3>Order: #{order.number}</h3>
            <span style={{ marginRight: "30px" }}>{currentTimer}</span>
          </OrderHeader>
          <Box
            display={"grid"}
            gridTemplateColumns={"auto"}
            gap="15px"
            mt={3}
            color={"#999"}
          >
            <span>
              School ID:{" "}
              {attributeValue}
            </span>
          </Box>
          <Box
            display={"grid"}
            gridTemplateColumns={"1.75fr 1fr"}
            gap="15px"
            mt={3}
            color={"#999"}
          >
            <span>
              Order date:{" "}
              {moment(order.created_at).format("ddd, MMM Do YYYY, h:mm a")}
            </span>
            <span>Client : {order.clientName}</span>
          </Box>
        </Box>
      </AccordionSummary>

      <OrderDetails
        fulfilled={fulfilled}
        order={order}
        markPick={markPick}
        handleMarkPick={handleMarkPick}
        handlePrint={handlePrint}
        handlePickupOrder={handlePickupOrder}
      />
    </AccDiv>
  );
};

export default OrderCard;
